export const environment = {
    production: true,
    apiUrl: 'https://my.zarenta.ru/api/v1'
};
